import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const langAtom = atomWithStorage("FAHAM_LANGUAGE", "FR");
export const hasLaunchedAtom = atomWithStorage("FAHAM_HASLAUNCHED", false);
export const isImagesLoadedAtom = atom(false);
